import React from 'react';
import fullStar from '../../assets/images/full-star.svg';
import halfStar from '../../assets/images/half-star.svg';
import emptyStar from '../../assets/images/empty-star.svg';

import './StarRating.css';

const StarRating = ({ rating, isReviewing, onRatingChange }) => {
  const safeRating = Math.min(Math.max(rating, 0), 5);
  const fullStars = Math.floor(safeRating); 
  const halfStars = safeRating % 1 >= 0.5 ? 1 : 0; 

  // Handle star click
  const handleClick = (starValue) => {
    if (isReviewing && onRatingChange) {
      onRatingChange(starValue);
    }
  };

  return (
    <div className={isReviewing ? "star-review star-rating" : "star-rating"}>
      {/* Render full stars */}
      {[...Array(5)].map((_, index) => {
        const starValue = index + 1;
        return (
          <img
            key={index}
            src={starValue <= fullStars ? fullStar : starValue === fullStars + 1 && halfStars ? halfStar : emptyStar}
            alt={`${starValue} Star`}
            onClick={() => handleClick(starValue)}
            className={isReviewing ? "clickable-star" : ""}
          />
        );
      })}
    </div>
  );
};

export default StarRating;

